import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
// THE CASCADE ORDER IS THE CONTRACT (missions' pattern): the kit's layered
// sheets first, then this app's unlayered ones, so app CSS wins ties the same
// way it did in the vanilla host (whose <head> declared the same order).
import '@ofself/shell/styles.css';
// .ofself-btn — imported via the kit's Button component so the exports map
// stays the door (the aggregate styles.css doesn't carry it).
import '@ofself/shell';
import '../public/styles/tokens.css';
import '../public/styles/base.css';
import '../public/styles/integrations.css';

createRoot(document.getElementById('root')).render(<App />);
